// extracted by mini-css-extract-plugin
export default {"app":"App_app__OLYuU","appContainer":"App_appContainer__oH4bX"};